import React from "react";
import Immutable from "immutable";
import { Date } from "./Date";

interface AuthorProps {
	author: Immutable.Map<string, string>;
	date: string;
}

export function Author({ author, date }: AuthorProps) {
	const name = author?.get("name");
	const photo = author?.get("photo");
	const uuid = author?.get("uuid");
	const slug = author?.get("slug");
	const isConfirmed = author?.get("is_confirmed");

	const published = <Date date={date} />;

	if (!isConfirmed || !name || !uuid || !slug) {
		return published;
	}

	const authorUrl = `/news/authors/${uuid}-${slug}`;

	return (
		<div className="post__author-info">
			<div className={`article_author-pic${photo ? " article_author-pic--has-photo" : ""}`}>
				{photo && (
					<a href={authorUrl}>
						<img src={photo} alt={name} />
					</a>
				)}
			</div>
			<div>
				<a href={authorUrl}>
					{name}
				</a>
				{published}
			</div>
		</div>
	);
}
